import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PhoneIcon = React.memo(
  ({ fill = variables['colors-mc-gray'], width = '25', viewBox = '0 0 25 25' }) => (
    <svg
      id='call'
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <path
        id='telephone'
        d='M4.111,1.494a.763.763,0,0,0-1.142-.071L1.806,2.587A1.93,1.93,0,0,0,1.3,4.579a19.763,19.763,0,0,0,4.689,7.434A19.765,19.765,0,0,0,13.422,16.7a1.93,1.93,0,0,0,1.991-.506l1.163-1.163a.763.763,0,0,0-.071-1.142l-2.6-2.018a.763.763,0,0,0-.652-.137l-2.464.615a1.963,1.963,0,0,1-1.864-.516L6.167,9.07A1.963,1.963,0,0,1,5.65,7.205l.616-2.464a.763.763,0,0,0-.137-.652ZM2.119.575A1.963,1.963,0,0,1,5.058.758L7.076,3.352A1.962,1.962,0,0,1,7.43,5.033L6.815,7.5a.763.763,0,0,0,.2.723l2.764,2.764a.763.763,0,0,0,.724.2l2.463-.615a1.963,1.963,0,0,1,1.681.354l2.594,2.018a1.963,1.963,0,0,1,.183,2.937l-1.163,1.163a3.124,3.124,0,0,1-3.237.79A20.963,20.963,0,0,1,5.139,12.86,20.963,20.963,0,0,1,.167,4.975,3.127,3.127,0,0,1,.957,1.738L2.121.575Z'
        transform='translate(3.5 3.5)'
        fill={fill}
        stroke={fill}
        strokeWidth='0.5'
      />
    </svg>
  )
);
PhoneIcon.displayName = 'PhoneIcon';

export default PhoneIcon;
